<template>
  <client-activity
    :tabs="userActivityTabNames()"
    :cart="products"
    :views="sortedLikesAndViews()"
    :loading="loading"
    :reverse="!isIntegrated"
    :last-updated="lastUpdated"
    :tab-types="{ TAB_SHOPPING_CART, TAB_VIEWS }"
  />
</template>
<script>
import Integrable from '@/components/mixins/integrable';
import ClientActivity from './ClientActivity';

export default {
  name: 'ClientActivityContainer',
  components: {
    ClientActivity,
  },
  mixins: [Integrable],
  props: {
    useFrontendFiltering: {
      type: Boolean,
      default: true, // historically, this was ON / true
      // default: false,
    },
  },
  computed: {
    profile() {
      return this.$store.state.account.user.profile;
    },
    customer() {
      return this.$store.state.customers.item;
    },
    loading() {
      return this.$store.state.customers.itemLoading
       || this.$store.state.outreachs.itemsLoading
       || this.$store.state.outreachs.customerViewsLoading;
    },
    products() {
      if (!this.customer || !this.customer.cart || !this.customer.cart.products) {
        return [];
      }
      return this.customer.cart.products;
    },
    views() {
      const response = {};
      const { customerViews } = this.$store.state.outreachs;
      if (!this.customer || !customerViews) return [];
      let filteredViews;

      if (this.useFrontendFiltering) {
        // If not admin mode, show only views for outreachs sent by us
        filteredViews = customerViews.filter((item) => this.$store.state.account.isAdminMode
          || item.outreach.sender.pk === this.profile.pk).map((item) => item.clicked_products).flat();
      } else {
        filteredViews = customerViews.map((item) => item.clicked_products).flat();
      }

      filteredViews.forEach((item) => {
        if (item.site_url in response) {
          response[item.site_url].count += 1;
        } else {
          response[item.site_url] = {
            ...item,
            count: 1,
          };
        }
      });

      return Object.keys(response).map((key) => response[key]);
    },
    likes() {
      const customerLikes = this.$store.state.customers.likes;
      if (!customerLikes || !customerLikes.collaterals || !customerLikes.products) {
        return [];
      }
      const collaterals = customerLikes.collaterals.map((item) => ({
        brand: {
          name: item.folder_name,
        },
        thumb: (item.image ? item.image : item.image_url),
        last_update: item.modified,
        is_like: true,
      }));
      const products = customerLikes.products.map((item) => {
        const newProduct = item.product;
        newProduct.last_update = item.modified;
        newProduct.appointment = item.appointment;
        newProduct.is_like = true;
        return newProduct;
      });
      return [...collaterals, ...products];
    },
    lastUpdated() {
      if (!this.customer || !this.customer.cart) {
        return '';
      }
      if (this.customer.cart.last_update) {
        return this.customer.cart.last_update;
      }
      return this.customer.cart.created;
    },
  },
  watch: {
    customer(newval) {
      if (newval && newval.pk) {
        this.$store.dispatch('outreachs/clearCustomerViews');
        this.$store.dispatch('outreachs/fetchViews', newval.pk);
        this.$store.dispatch('customers/retrieveCustomerLikes', newval.pk);
      }
    },
  },
  methods: {
    sortedLikesAndViews() {
      /*
          David notes 6/18/21 having never looked at this before :D

            - Both 'likes' & 'views' appears to be from ProductShallowSerializer
              (and NOT a ProductImageLike or OutReach)
       */
      const arr = [...this.views, ...this.likes];
      arr.sort((first, two) => {
        const d1 = Date.parse(first.last_update);
        const d2 = Date.parse(two.last_update);
        let ret;
        if (d1 === d2) {
          ret = 0;
        } else if (d1 < d2) {
          ret = -1;
        } else {
          ret = 1;
        }
        return ret;
      });
      arr.reverse(); // because we want MOST RECENT first (on the left)

      /*
      console.log(`sortedLikesAndViews()  views.length: ${this.views.length} `
                  + `  likes.length: ${this.likes.length} `
                  // + `  arr: ` + JSON.stringify(arr)
      );
       */

      return arr;
    },
  },
};
</script>
